import React from "react";
import "./CounterInput.scss";

interface CounterInputProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
}

const CounterInput: React.FC<CounterInputProps> = ({
  label,
  value,
  onChange,
  min = 1,
  max = 10
}) => {
  const handleDecrement = () => {
    if (value > min) {
      onChange(value - 1);
    }
  };

  const handleIncrement = () => {
    if (value < max) {
      onChange(value + 1);
    }
  };

  return (
    <div className="setting-item">
      <label className="setting-label">{label}</label>
      <div className="setting-control">
        <div className="counter-input">
          <div className="counter-value">{value}</div>
          <div className="counter-buttons">
            <button
              analytics-id="counter-input-increment-btn"
              className="counter-button increment"
              onClick={handleIncrement}
              disabled={value >= max}
              aria-label="Increment"
            >
              <div className="chevron-up"></div>
            </button>
            <button
              analytics-id="counter-input-decrement-btn"
              className="counter-button decrement"
              onClick={handleDecrement}
              disabled={value <= min}
              aria-label="Decrement"
            >
              <div className="chevron-down"></div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CounterInput;
